// NGRX
import { createFeatureSelector } from '@ngrx/store';
import { EntityState, EntityAdapter, createEntityAdapter } from '@ngrx/entity';
// Actions
import { ActionActions, ActionActionTypes } from '../_actions/action.actions';
// CRUD
import { QueryParamsModel } from '../../_base/crud';
// Models
import { ActionModel } from '../_models/action.model';

// tslint:disable-next-line:no-empty-interface
export interface ActionsState extends EntityState<ActionModel> {
  listLoading: boolean;
  actionsloading: boolean;
  totalCount: number;
  lastCreatedActionId: number;
  lastCreatedAction: ActionModel;
  lastQuery: QueryParamsModel;
  error: any;
  latestSuccessfullAction: any;
  showInitWaitingMessage: boolean;
}

export const adapter: EntityAdapter<ActionModel> = createEntityAdapter<ActionModel>();

export const initialActionsState: ActionsState = adapter.getInitialState({
  listLoading: false,
  actionsloading: false,
  totalCount: 0,
  error: null,
  latestSuccessfullAction: null,
  lastQuery: new QueryParamsModel({}),
  lastCreatedActionId: undefined,
  lastCreatedAction: undefined,
  showInitWaitingMessage: true,
});

export function actionsReducer(state = initialActionsState, action: ActionActions): ActionsState {
  switch (action.type) {
    case ActionActionTypes.ActionsPageToggleLoading:
      return {
        ...state,
        listLoading: action.payload.isLoading,
        lastCreatedActionId: undefined,
      };
    case ActionActionTypes.ActionsActionToggleLoading:
      return {
        ...state,
        actionsloading: action.payload.isLoading,
      };
    case ActionActionTypes.ActionCreated:
      return adapter.addOne(action.payload.action, {
        ...state,
        lastCreatedActionId: action.payload.action.id,
        lastCreatedAction: action.payload.action,
      });
    case ActionActionTypes.ActionUpdated:
      return adapter.updateOne(action.payload.partialAction, state);
    case ActionActionTypes.ActionDeleted:
      return adapter.removeOne(action.payload.id, state);
    case ActionActionTypes.ActionsPageCancelled:
      return {
        ...state,
        listLoading: false,
        lastQuery: new QueryParamsModel({}),
      };
    case ActionActionTypes.ActionsPageLoaded: {
      return adapter.addMany(action.payload.actions, {
        ...initialActionsState,
        totalCount: action.payload.totalCount,
        lastQuery: action.payload.page,
        showInitWaitingMessage: false,
        latestSuccessfullAction: state.latestSuccessfullAction,
        error: null,
      });
    }
    case ActionActionTypes.ThrowActionError: {
      return {
        ...state,
        error: action.payload.error,
        actionsloading: false,
        listLoading: false,
      };
    }
    case ActionActionTypes.FireActionSuccess: {
      return {
        ...state,
        latestSuccessfullAction: { action_type: action.payload.action_type },
        error: null,
      };
    }
    case ActionActionTypes.ClearActionState: {
      return initialActionsState;
    }
    default:
      return state;
  }
}

export const getActionState = createFeatureSelector<ActionsState>('actions');

export const { selectAll, selectEntities, selectIds, selectTotal } = adapter.getSelectors();
